<template>
  <div class="" id="trackPaginate" v-if="JobType != 'RVP'">
    <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingAllocationShipmentListLoader" />
    <table class="b-table table table-bordered pending-for-delivery-ShipmentList">
        <thead class="thead-default">
        <tr>
          <th>Shipping ID</th>
          <th>Pending Days</th>
          <th>Shipment Type</th>
          <th>Handover Date</th>
          <th>Customer Address</th>
        </tr>
        </thead>
        <tbody>
          <template v-if="PendingForAllocationShipmentList.length > 0" >
            <tr v-for="row in PendingForAllocationShipmentList">
              <td>{{row.shippingid}}</td>
              <td>{{row.pendingdays }}</td>
              <td>{{row.shipmenttype}}</td>
              <td>{{row.handoverdate | moment }}</td>
              <td>{{row.shipaddress}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="7" align="center">No record found</td>
            </tr>
          </template>
        </tbody>
    </table>
    <paginate ref="paginate" :page-count="pageCount" :page-range="2" :margin-pages="2" :click-handler="getPaginationData" :prev-text="'<<'" :next-text="'>>'" :container-class="'pagination'">
    </paginate>
  </div>
  <div class="" id="trackPaginate" v-else="">
    <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingAllocationShipmentListLoader" />

    <table class="b-table table table-bordered pending-for-delivery-ShipmentList">
        <thead class="thead-default">
        <tr>
          <th class="text-center tableheader">
            <label>
              <input type="checkbox" v-model="checkAll" @click="selectAllShipments($event)">
            </label>
          </th>
          <th>Shipping ID</th>
          <th>Pending Days</th>
          <th>Shipment Type</th>
          <th>Handover Date</th>
          <th>Customer Address</th>
        </tr>
        </thead>
        <tbody>
          <template v-if="PendingForAllocationShipmentList.length > 0" >
            <tr v-for="row in PendingForAllocationShipmentList">
              <td scope="row" class="text-center">
                <input type="checkbox" v-model="selectedReverseShipmentData" :value="row.shippingid" name="selectedPickups" @click="PassSelectedData()" style="font-size:0.8em;">
              </td>
              <td>{{row.shippingid}}</td>
              <td>{{row.pendingdays }}</td>
              <td>{{row.shipmenttype}}</td>
              <td>{{row.handoverdate | moment }}</td>
              <td>{{row.shipaddress }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="7" align="center">No record found</td>
            </tr>
          </template>
        </tbody>
    </table>
    <paginate ref="paginate" :page-count="pageCount" :page-range="2" :margin-pages="2" :click-handler="getPaginationData" :prev-text="'<<'" :next-text="'>>'" :container-class="'pagination'">
    </paginate>
  </div>
</template>



<script>
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'

export default {
  name: 'pendingForAllocationShipments',
  components: {
    VueElementLoading,
    Paginate
  },
  data: function() {
    return{
      selectedReverseShipmentData: [],
      checkAll: false
    }
  },
  props: {
    PendingForAllocationShipmentList: {
      type: Array,
      required: true,
    },
    isPendingAllocationShipmentListLoader: {
      type: Boolean,
      required: true,
    },
    JobType: {
      type: String,
      required: true,
    },
    pageCount: {
      type: Number
    },
    // totalPendingShipmentforDeliverycnt: {
    //   type: Number
    // }
  },
  watch: {
    isPendingAllocationShipmentListLoader(){
      this.selectedReverseShipmentData = [];
      this.checkAll = false;
      this.PassSelectedData();
    }
  },
  methods: {
    getPaginationData(pageNum){
      this.$emit("getPaginationDataChild", pageNum);
    },
    selectAllShipments(ev) {
      this.selectedReverseShipmentData = [];
      if (ev.target.checked == true) {
        $.each(this.PendingForAllocationShipmentList, (key,value) => {
          this.selectedReverseShipmentData.push(value.shippingid);
          this.$emit("getSelectedShipments", this.selectedReverseShipmentData);
        })
      }
    },
    PassSelectedData(){
      this.$emit("getSelectedShipments", this.selectedReverseShipmentData);
    },
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/pendingForAllocationShipments.vue?7e4e3e76